import { ValidationService } from '../../scripts/aspnet-validation';

let v = new ValidationService();

const mustbetrue = function (value, element, params) {
    if (element.type && element.type === 'checkbox') {
        return element.checked;
    }
    return !value;
};

const filesize = function (value, element, params) {
    if (!element.files || !element.files.length) {
        return true;
    }

    let totalFileSize = true;
    const { max } = params;

    Array.from(element.files).forEach(function (file) {
        totalFileSize = totalFileSize + file.size;
    });

    return totalFileSize <= parseInt(max, 10);
};

const extension = function (value, element, params) {
    if (!element.files || !element.files.length) {
        return true;
    }

    const { extensions } = params;

    if (!extensions) {
        console.warn('Extension are blank!')
        return true;
    }

    let isValid = true;

    Array.from(element.files).forEach(function (file) {
        if (!isValid) {
            return;
        }

        if (file.name.indexOf('.') === -1) {
            isValid = false;
        }

        const extension = file.name.split('.').pop();

        if (!extensions.includes(extension.toLowerCase())) {
            isValid = false;
        }
    });

    return isValid;
};

v.addProvider("mustbetrue", mustbetrue);
v.addProvider("filesize", filesize);
v.addProvider("extension", extension);

v.bootstrap();